import { useHistory } from 'react-router-dom';
import { ReactComponent as LeftAngleIcon } from '../../Icons/AngleLeft.svg';

const BackButton = ({ onClick, color, style, noPadding }) => {
  const history = useHistory();
  const box = {
    height: 32,
    width: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (onClick && onClick instanceof Function) {
          onClick();
        } else {
          history.goBack();
        }
      }}
      style={{
        ...(!noPadding
          ? box
          : {
              width: 32,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }),
        ...style,
      }}
    >
      {' '}
      <LeftAngleIcon height={14} width={14} onClick={() => {}} color={color} />
    </button>
  );
};

export default BackButton;
